import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styles from './elements-group.module.css';
import { Button } from '../button';
import { useState } from 'react';
import { Popover } from '../popover';
export const ElementsGroup = ({ elements, limit, title, }) => {
    const initialElements = limit ? elements.slice(0, limit) : elements;
    const remainingElements = elements.slice(initialElements.length);
    return (_jsxs("div", { className: styles.group, children: [initialElements, remainingElements.length > 0 && (_jsx(RemainingElements, { elements: remainingElements, title: title }))] }));
};
const RemainingElements = ({ elements, title, }) => {
    const { t } = useTranslation(undefined, {
        keyPrefix: 'elements-group',
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const openPopover = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const closePopover = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Button, { sx: { padding: 1 }, onClick: openPopover, children: ["+ ", elements.length, " ", t('more'), "..."] }), _jsx(Popover, { open: Boolean(anchorEl), onClose: closePopover, anchorEl: anchorEl, title: title, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, children: _jsx("div", { className: styles.group, children: elements }) })] }));
};
